import React, { Component } from "react";
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { Container, Row, Col } from "shards-react";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';

import EfectoresSearchBar from "../../components/efectores/search-bar";
import LocationItemRow from "../../components/locations/location-item-row";

import EfectorModalForm from "../../components/efectores/efector-modal-form";
import EfectorModalImport from "../../components/efectores/efector-modal-import";

import { efectorlistActions, getCurrentEfectorList, getEfectoresForCurrentEfectorList } from "../../core/efector-lists";
import { efectorActions, getCurrentEfector, createEfector } from "../../core/efectores";

import { specialtiesListActions, getCurrentSpecialtiesLists } from "../../core/specialties-lists";
import { locationsListActions } from "../../core/locations-lists";
import { provincesListActions, getCurrentProvincesLists } from "../../core/provinces-lists";
import { DEFAULT_PER_PAGE } from "../../core/constants";
import { api } from "../../core/api";
import  LoadingIndicator from '../../components/common/loading-indicator'
import { Popup as PopupResendLoginMail } from "../../components/common/Popup";

class AdminPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_popup_form: false,
      current_item: null,
      data_efector: null,
      show_popup_import: false,
      show_popup_resend: false
    }

    this.toggleModalResendLoginMail = this.toggleModalResendLoginMail.bind(this);
    this.handleResendLoginMail = this.handleResendLoginMail.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleImport = this.handleImport.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.loadData = this.loadData.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchEfectorByDNI = this.handleSearchEfectorByDNI.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseImportModal = this.handleCloseImportModal.bind(this);
  }

  componentWillMount() {
    const { authenticated, user, efectorlist } = this.props

    if (authenticated && user.sessionId && !efectorlist.isPending)
      this.loadData()
  }

  loadData(){
    const { user,  loadEfectores, loadProvinces, loadSpecialties } = this.props
    loadEfectores(new Map({
      sessionId: user.sessionId
    }))
    //loadLocations( user.sessionId )
    loadSpecialties( user.sessionId )
    loadProvinces( user.sessionId )
  }

  componentDidUpdate(oldProps,oldState){
    const { user,  authenticated, efectorlist} = this.props

    if ( authenticated &&  oldProps.user.sessionId !== user.sessionId ){
      this.loadData()
    }

  }

  handleKeyPress(event){

    if (event.which === 13 || event.keyCode === 13) {
      this.handleSearch(event)
    }
  }

  handleSearch(event) {
    const { user,  loadEfectores } = this.props
    const { search } = this.state

    loadEfectores(new Map({
      sessionId: user.sessionId,
      search
    }))
  }

  handleResendLoginMail(efector){
    api.resendLoginMailEfector(efector.id).then((response) => {
        if ( response.error && response.error.code === 0 ) {
            this.toggleModalResendLoginMail()
        }
    })
  }

  toggleModalResendLoginMail(){
    this.setState({
      show_popup_resend: !this.state.show_popup_resend
    })
  }

  handleEdit(efector){
    this.setState({
      show_popup_form: true,
      current_item: efector ? efector.id : null
    });
  }

  handleImport(){
    this.setState({
      show_popup_import: true,
    });
  }

  handleDelete( efector ){

    if ( !window.confirm('¿Estás seguro de que deseas eliminar el elemento?') )
    return false;

    this.props.deleteEfector(efector.id)

  }

  handleChange(key,event) {

    const { [key]: _value } = this.state
    const value = event.target.value;

    if ( value !== _value ) {
      this.setState({
          [key]: value
      });
    }
  }

  handleCloseModal(){
    this.setState({
      show_popup_form: false,
      current_item: null,
      data_efector: null,
    });
  }

  handleCloseImportModal(){
      this.setState({
        show_popup_import: false,
      })
  }

  handleSearchEfectorByDNI(dni){
    const { user } = this.props

    api.fetchEfectorByDNI({ dni, sessionId:user.sessionId }).then((response) => {
      let current_item = null
      let data_efector = null
      if ( response.error && response.error.code === 0 ) {
          current_item = response.data.id
          data_efector = createEfector(response.data)
      }
      this.setState({
        current_item,
        data_efector
      });
    })
  }

  render() {
    const { efectores, specialties, locations, displayLoadingIndicator } = this.props
    const { show_popup_form, current_item, data_efector, show_popup_import, show_popup_resend } = this.state


    if ( displayLoadingIndicator )
      return (<Container className="main-content-container h-100 px-4 container-fluid">
        <Row className="h-100 no-gutters">
          <Col className="auth-form mx-auto my-auto col-md-5 col-lg-4">
              <LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }}/>
          </Col>
        </Row>
      </Container>);

    if (!efectores)
      return null;

    const columns = [
      {
        text: 'Apellido y Nombre',
        dataField: 'apellido',
        sort:true,
        formatter: (cell, row) => (
          <span>
            { row ? `${row.apellido}, ${row.nombre}` : '' }
          </span>
        ),
        filterValue: (cell, row) =>{
            if (!row)
              return ''

          return `${row.apellido} ${row.nombre}`
        }
      },
      {
        text: 'Especialidad',
        dataField: 'especialidad',
        sort:true,
        formatExtraData: specialties,
        formatter: (cell, row) => {
          let text = ""
          if (specialties && row && row.especialidadId){
            const specialtie = specialties.items.find(  specialtie => specialtie.id === row.especialidadId )
            if ( specialtie )
              text = specialtie.descripcion
          }
          return (
              <span>
                { `${text}` }
              </span>
            )
        },
        filterValue: (cell, row) => {
          let text = ""
          if (specialties && row && row.especialidadId){
            const specialtie = specialties.items.find(  specialtie => specialtie.id === row.especialidadId )
            if ( specialtie )
              text = specialtie.descripcion
          }
          return `${text}`
        }
      },
      {
        text: 'E-mail',
        dataField: 'email',
        sort:true,
        style: { overflow: 'hidden' }
      },
      {
        text: 'Telefono',
        dataField: 'telefono',
        sort:true,
        formatter: (cell, row) => (
          <span>
            { row.telefono1 } / { row.telefono2 }
          </span>
        ),
       filterValue: (cell, row) => `${row.telefono1} ${row.telefono2}`

      },
      {
        text: 'Localidad',
        dataField: 'localidad',
        sort:true,
        formatExtraData: locations,
        formatter: (cell, row) => <LocationItemRow locationId={row.localidadId } />,
        filterValue: (cell, row) => {
          let text = ""
          if ( locations ) {
            const location = locations.find(  location => location.id === row.localidadId )
            if ( location )
              text = `${location.nombre} - ${location.provincia.nombre}`
          }
          return `${text}`
        }
      },
      {
        dataField:'actions',
        text:'',
        formatter: (cell, row)  => <div className="btn-group-sm btn-group">
        <button className="btn text-secondary" onClick={(e)=>this.handleResendLoginMail(row,e)}><i className="fa fa-envelope"></i></button>
        <button className="btn text-secondary" onClick={(e)=>this.handleEdit(row,e)}><i className="material-icons"></i></button>
        <button className="btn text-secondary" onClick={(e)=>this.handleDelete(row,e)}><i className="fa fa-trash"></i></button>

        </div>,
        headerStyle: () => {
          return { width: "150px" };
        },

      }
    ]

    return(
      <Container fluid className="main-content-container col-12">
      <EfectorModalForm show={show_popup_form} efector_id={current_item} data_efector={data_efector} handleClose={this.handleCloseModal} handleSearchEfectorByDNI={this.handleSearchEfectorByDNI} />
      <EfectorModalImport show={show_popup_import} handleClose={this.handleCloseImportModal} />
      <ToolkitProvider keyField="id" data={ efectores.toJS()  } columns={ columns } search >
        {
          props => (
            <div>
              <EfectoresSearchBar { ...props.searchProps }  handleEdit={this.handleEdit} handleImport={this.handleImport} /> 

              <BootstrapTable {...props.baseProps}
                wrapperClasses="table-fixed-head"
                bordered={ false }
                headerClasses="rdt_TableHead"
                hover
                condensed
                pagination={ paginationFactory({
                  hideSizePerPage:true,
                  sizePerPage: DEFAULT_PER_PAGE,
                  hidePageListOnlyOnePage:true
                }) }
                loading={ displayLoadingIndicator }
                />
            </div>
          )
        }
      </ToolkitProvider>
      <PopupResendLoginMail show={show_popup_resend} toggle={this.toggleModalResendLoginMail} message="Los datos de acceso han sido enviados al Efector" showCloseBtn={false} />
      </Container>
    )
  }
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  //console.log('mapStateToProps', state, props)
  const efectorlist = getCurrentEfectorList(state, props)

  let isPending = true
  if ( efectorlist )
    isPending = efectorlist.isPending

  return {
    user: state.session.user,
    authenticated: state.session.authenticated,
    efectorlist,
    efectores: getEfectoresForCurrentEfectorList(state, props),
    specialties: getCurrentSpecialtiesLists(state, props),
    provinces: getCurrentProvincesLists(state, props),
    locations: state.locations,
    displayLoadingIndicator: isPending,

  };
};

const mapDispatchToProps = {
  loadEfectores: efectorlistActions.loadEfectores,
  deleteEfector: efectorActions.deleteEfector,
  navigateToEfector:  efectorlistActions.navigateToEfector,
  loadLocations : locationsListActions.loadLocations,
  loadSpecialties : specialtiesListActions.loadSpecialties,
  loadProvinces : provincesListActions.loadProvinces,
  resendLoginMailEfector: efectorActions.resendLoginMail,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminPage);
